import { render, staticRenderFns } from "./userCenter.vue?vue&type=template&id=64ecba45&scoped=true&"
import script from "./userCenter.js?vue&type=script&lang=js&"
export * from "./userCenter.js?vue&type=script&lang=js&"
import style0 from "./userCenter.vue?vue&type=style&index=0&id=64ecba45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ecba45",
  null
  
)

export default component.exports